import { useAccountContext } from '@/context/account'
import { SafetyPanel } from '../sidePanel/safetyPanel'
import { TxNotSupportedPanel } from '../sidePanel/txNotSupportedPanel'
import { TxWidget } from '../sidePanel/txWidget'
import { TxContextError } from './txContextError'
import type { TxPanelSharedProps } from './txPanel'
import { TxPanelSkeleton } from './txPanelSkeleton'
import { TxSubmissionGuard } from './txSubmissionGuard'

type TxPanelContentProps = Pick<
  TxPanelSharedProps,
  | 'vault'
  | 'transactionsContext'
  | 'tabValue'
  | 'setTabValue'
  | 'tabsConfig'
  | 'isContextError'
  | 'isContextFetching'
  | 'onRetryContext'
>

export const TxPanelContent = ({
  transactionsContext,
  isContextError,
  isContextFetching,
  onRetryContext,
  ...widgetProps
}: TxPanelContentProps) => {
  const { account } = useAccountContext()
  if (!widgetProps.vault.isTransactional) {
    return <TxNotSupportedPanel protocolVaultUrl={widgetProps.vault.protocolVaultUrl} />
  }

  if (!transactionsContext && !isContextError) return <TxPanelSkeleton />

  return (
    <>
      {transactionsContext && (
        <>
          <SafetyPanel />
          <TxSubmissionGuard blocked={isContextError}>
            <TxWidget key={account?.toLowerCase()} {...widgetProps} transactionsContext={transactionsContext} />
          </TxSubmissionGuard>
        </>
      )}
      {isContextError && (
        <TxContextError
          variant={transactionsContext ? 'refresh' : 'initial'}
          isFetching={isContextFetching}
          onRetry={onRetryContext}
        />
      )}
    </>
  )
}
